import { render, staticRenderFns } from "./_ship-scene.vue?vue&type=template&id=adbb1668&scoped=true&"
import script from "./_ship-scene.vue?vue&type=script&lang=js&"
export * from "./_ship-scene.vue?vue&type=script&lang=js&"
import style0 from "./_ship-scene.vue?vue&type=style&index=0&id=adbb1668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbb1668",
  null
  
)

export default component.exports